var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex space-x-2 text-orange-500 select-none"},[_c('BaseIcon',{staticClass:"w-6 h-6",attrs:{"name":_vm.iconName}}),_c('span',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }